import { Icon } from '@mage-ui/components';
import { cx } from '@mage-ui/styled-system/css';
import {
	icon,
	overlayButton,
	toastBody,
	toastCloseButton,
	toastDescription,
	toastNotification,
	toastNotificationRoot,
	toastRoot,
	toastSettings,
	toastTitle,
} from '@mage-ui/styled-system/recipes';
import { Notifications, notifications } from '@mantine/notifications';

export const toast = ({
	status,
	classNames,
	startSlot,
	position = 'top-center',
	...props
}) => {
	const icons = {
		success: <Icon name='info_fill' classNames={icon({ size: 'm' })} />,
		error: <Icon name='cancel' classNames={icon({ size: 'm' })} />,
		warning: <Icon name='info_fill' classNames={icon({ size: 'm' })} />,
	};

	notifications.show({
		classNames: {
			root: cx(toastSettings({ status }), classNames?.root || toastRoot()),
			body: classNames?.body || toastBody(),
			title: classNames?.title || toastTitle(),
			closeButton:
				classNames?.closeButton || cx(overlayButton(), toastCloseButton()),
			description: classNames?.description || toastDescription(),
		},
		icon: startSlot || icons[status || 'success'],
		position,
		...props,
	});
};

export const Toast = ({ classNames }) => {
	return (
		<Notifications
			classNames={{
				root: classNames?.root || toastNotificationRoot(),
				notification: classNames?.notification || toastNotification(),
			}}
		/>
	);
};
